export const localizationOptions = {
  textLabels: {
    body: {
      noMatch: 'No se han encontrado registros que coincidan con la búsqueda',
      toolTip: 'Ordenar',
      columnHeaderTooltip: (column: any) => `Orden para ${column.label}`,
    },
    pagination: {
      next: 'Próxima',
      previous: 'Anterior',
      rowsPerPage: 'Registros por página:',
      displayRows: 'de',
      jumpToPage: 'Ir a la página',
    },
    toolbar: {
      search: 'Buscar',
      downloadCsv: 'Descargar',
      print: 'Imprimir',
      viewColumns: 'Ver columnas',
      filterTable: 'Filtrar tabla',
    },
    filter: {
      all: 'Todos',
      title: 'FILTROS',
      reset: 'LIMPIAR',
    },
    viewColumns: {
      title: 'Ver columnas',
      titleAria: 'Ver/Ocultar columnas',
    },
    selectedRows: {
      text: 'registro(s) seleccionado',
      delete: 'Borrar',
      deleteAria: 'Borrar columnas seleccionadas',
    },
  },
};
